<template>
  <div class="web-footer">
    <div class="web-bottom">
      <ul>
        <li>
          <router-link to="/privacy">隐私政策</router-link>
        </li>
        <li>
          <router-link to="/terms">使用条款</router-link>
        </li>
        <li>
<!--          <router-link to="/about/company">关于卓讯</router-link>-->
        </li>
        <li>
<!--          <router-link to="/experience">产品体验</router-link>-->
        </li>
        <li>
<!--          <router-link to="/cooperation">联系我们</router-link>-->
        </li>
      </ul>
      <div class="copy">
        <a href="https://beian.miit.gov.cn/">粤ICP备20050702号-1</a> <span>|广州卓讯互动信息技术有限公司.All rights reserved.&nbsp;&nbsp;&nbsp;</span>&nbsp;
      </div>
      <div class="copy" style="font-size: 10px">
        <div style="margin-bottom: 8px">
          <a target="_blank" href="https://banma-sz.oss-cn-shenzhen.aliyuncs.com/zhuo_xun/icp/icp.html">增值电信经营业务经营许可证粤B2-20180087</a>
        </div>
        <div>游戏健康忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    props: ['Mytype'],
    data() {
      return {
        localUrl: window.location.href,
        recordNum: 17125925, //备案号
      }
    },
    created() {
      // if(this.localUrl.indexOf('yongwangkeji.cn')>=0){
      //   this.recordNum = '17025202';
      // }else if(this.localUrl.indexOf('localhost')>=0){
      //   this.recordNum = 'akhfaks1241412';
      // }else{
      //   this.recordNum = 'akhfaks';
      // }
    }
  }
</script>

<style>

  #app {
    width: 100%;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/myFooter.vue